'use strict';

module.exports = {
    heroBannerBackgroundLink: function () {
        $(document).on('click', '.clickable-mbb-in-grid-banner-js', function (e) {
            if ($(e.target).parent('.cta-container-js').length === 0) {
                window.location.href = $(this).data('target');
            }
        })
    }
};
